import React, { useEffect, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
import '../../../../assets/css/customer/publicCustomerCss/CusPackages/cuspackages.css';

const PaymentSuccessScreen = () => {
    const [searchParams]    = useSearchParams();
    const navigate          = useNavigate();
    const { baseUrl, authToken } = useContext(AppContext);

    const bookingId  = searchParams.get('booking_id');
    const sessionId  = searchParams.get('session_id');

    useEffect(() => {
        if (!sessionId || !bookingId) return;
        axios
            .post(
                `${baseUrl}/customer/payment/verify`,
                { session_id: sessionId, jjbooking_id: bookingId },
                { headers: { Authorization: `Bearer ${authToken}` } }
            )
            .catch((err) => console.error('Payment verify error:', err));
    }, [sessionId, bookingId]);

    const handleContinue = () => {
        const pkgId = localStorage.getItem('lastViewedPackage');
        pkgId ? navigate(`/packages/${pkgId}`) : navigate('/packages');
    };

    return (
        <div className="pss-wrap">
            <div className="pss-card">
                <div className="pss-icon-wrap">
                    <FaCheckCircle className="pss-icon" />
                </div>
                <h1 className="pss-title">Payment Successful!</h1>
                <p className="pss-sub">
                    Your reservation has been confirmed. A confirmation will be sent to your contact no.
                </p>
            
                <div className="pss-actions">
                    <button className="pss-btn-primary" onClick={handleContinue}>
                        Back to Package <FaArrowRight />
                    </button>
                    <button
                        className="pss-btn-secondary"
                        onClick={() => navigate('/customer/dashboard')}
                    >
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccessScreen;